import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../../contexts/AuthContext'
import { useFetch } from '../useFetch'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

type PartnerInvitation = {
  email: string
}

export function usePartnerInvite() {
  const { authInfo } = useAuth()
  const { t } = useTranslation(['partners', 'exceptions'])
  const { poster } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const partnerInvite = async (email: string) => {
    setLoading(true)
    try {
      const invitation: PartnerInvitation = { email }

      await poster<void>(
        `${CONFIG.BOUNCE_API}/api/v1/partners/invitations`,
        invitation,
        'application/json'
      )
      setSuccess(t('partners:partners.hook.successfully-invited'))
      setError(null)
      return true
    } catch (error) {
      console.error(error)
      if (error instanceof ApiError) {
        setError(getErrorMessage(error.data))
      } else {
        setError(t('exceptions:unknown'))
      }
      return false
    } finally {
      setLoading(false)
    }
  }
  return {
    partnerInvite,
    loading,
    error,
    success,
    resetState,
  }
}
